// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Icon_color-primary__eih8a {
  color: var(--primary-color);
}

.Icon_color-secondary__eWJ9b {
  color: var(--secondary-color);
}

.Icon_color-accent__fu5QP {
  color: var(--accent-color);
}

.Icon_color-warning__t0FIN {
  color: orange;
}

.Icon_color-error__Ih8kM {
  color: #df6767;
}

.Icon_color-grey-300__kHw-J {
  color: #acacac;
}

.Icon_color-grey-400__Ae4M2 {
  color: #838383;
}

.Icon_color-white__-FSYU {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/_common/components/Icon/Icon.module.scss","webpack://./src/_common/scss/_colors.scss"],"names":[],"mappings":"AAEA;EACE,2BCHQ;ADEV;;AAIA;EACE,6BCNU;ADKZ;;AAIA;EACE,0BCTO;ADQT;;AAIA;EACE,aCHQ;ADEV;;AAIA;EACE,cCNM;ADKR;;AAIA;EACE,cCfS;ADcX;;AAIA;EACE,cClBS;ADiBX;;AAIA;EACE,WCjBM;ADgBR","sourcesContent":["@import '@common/scss/_colors';\n\n.color-primary {\n  color: $primary;\n}\n\n.color-secondary {\n  color: $secondary;\n}\n\n.color-accent {\n  color: $accent;\n}\n\n.color-warning {\n  color: $warning;\n}\n\n.color-error {\n  color: $error;\n}\n\n.color-grey-300 {\n  color: $grey-300;\n}\n\n.color-grey-400 {\n  color: $grey-400;\n}\n\n.color-white {\n  color: $white;\n}\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-primary": `Icon_color-primary__eih8a`,
	"color-secondary": `Icon_color-secondary__eWJ9b`,
	"color-accent": `Icon_color-accent__fu5QP`,
	"color-warning": `Icon_color-warning__t0FIN`,
	"color-error": `Icon_color-error__Ih8kM`,
	"color-grey-300": `Icon_color-grey-300__kHw-J`,
	"color-grey-400": `Icon_color-grey-400__Ae4M2`,
	"color-white": `Icon_color-white__-FSYU`
};
export default ___CSS_LOADER_EXPORT___;
